<template>
  <div
    class="bg-black text-white font-console leading-tight w-full h-full overflow-x-hidden overflow-y-auto p-6 sm:p-8 md:px-10"
  >
    <div class="max-w-7xl mx-auto">
      <slot>
        <div class="mb-10 relative">
          <div class="flex flex-wrap md:absolute md:w-full">
            <div
              class="flex-auto flex-grow-0 w-full md:pb-4 md:w-auto md:pr-12"
            >
              <work-header
                ><h1 class="inline-block">case studies</h1></work-header
              >
            </div>
            <div class="flex-auto pb-4 w-full md:w-auto md:pr-8">
              <p>
                dayjob is a small:full service studio<br
                  class="hidden md:inline"
                />
                based in
                <span class="inline-block">los angeles, california</span>
              </p>
            </div>
            <div class="flex-auto flex-grow-0 pb-4 w-full md:w-auto">
              <p class="lowercase">
                <span class="inline-block">all inquiries:&nbsp;</span>
                <a href="mailto:info@dayjob.work">info@dayjob.work</a><br />
                <span class="inline-block">1234 Sunset Blvd,</span> Los Angeles
              </p>
            </div>
          </div>
          <div>
            <div class="hidden invisible md:block">&nbsp;</div>
            <h4>Terminal parameters</h4>
            <ul class="table">
              <li class="table-row">
                <span class="table-cell text-right w-20 sm:w-32"
                  >Company:&nbsp;</span
                >
                <span class="table-cell">Day Job</span>
              </li>
              <li class="table-row">
                <span class="table-cell text-right w-20 sm:w-32"
                  >Established:&nbsp;</span
                >
                <span class="table-cell">2018</span>
              </li>
              <li v-if="tags && tags.length" class="table-row">
                <span class="table-cell text-right w-20 sm:w-32"
                  >Disciplines:&nbsp;</span
                >
                <span class="table-cell">
                  <work-tags :tags="tags" />
                </span>
              </li>
            </ul>
          </div>
        </div>
        <work-project
          v-for="project in projects"
          v-bind="project"
          :key="project.id"
          class="mb-10"
        />
        <!-- <garfield-ascii
          v-observe-visibility="visibilityObserve"
          class="py-20"
        /> -->
      </slot>
    </div>
  </div>
</template>

<script>
import WorkHeader from '@/app/components/work/WorkHeader.vue'
import WorkTags from '@/app/components/work/WorkTags.vue'
import WorkProject from '@/app/components/work/WorkProject.vue'
// import GarfieldAscii from '@/app/components/GarfieldAscii.vue'
import tagsQuery from '@/app/graphql/queries/tags.gql'
import projectsQuery from '@/app/graphql/queries/projects.gql'

export default {
  name: 'Work',

  components: {
    WorkHeader,
    WorkProject,
    WorkTags
    // GarfieldAscii
  },

  data: () => ({
    initialized: false,
    visible: false
  }),

  apollo: {
    tags: {
      query: tagsQuery
    },

    projects: {
      query: projectsQuery
    }
  },

  computed: {
    visibilityObserve() {
      const init = this.initialized
      if (!init) {
        return false
      }
      return {
        callback: this.visibilityChange,
        threshold: 0.3,
        once: true
      }
    }
  }
}
</script>
